import React, { createContext, useContext, type ReactNode } from 'react';

import type { CompanionWorkspace } from './types';
import { useCompanionWorkspace } from './hooks/useCompanionWorkspace';

const CompanionWorkspaceContext = createContext<CompanionWorkspace | undefined>(
  undefined
);

type Props = { children: ReactNode };

export const CompanionWorkspaceProvider = ({ children }: Props) => {
  const workspace = useCompanionWorkspace();

  return (
    <CompanionWorkspaceContext.Provider value={workspace}>
      {children}
    </CompanionWorkspaceContext.Provider>
  );
};

export const useCompanionWorkspaceContext = (): CompanionWorkspace => {
  const workspace = useContext(CompanionWorkspaceContext);
  if (!workspace) {
    throw new Error(
      'useCompanionWorkspaceContext must be used within CompanionWorkspaceProvider'
    );
  }
  return workspace;
};
